/* eslint-disable lingui/no-unlocalized-strings */
import { Capacitor } from "@capacitor/core";
import {
  KeychainAccess,
  StorageErrorType,
  SecureStorage,
  StorageError,
} from "@aparajita/capacitor-secure-storage";

/**
 * Save JWT access token for persistent login
 * Web: Tokens are stored in HTTP-only cookies by backend
 * Mobile: Store in SecureStorage for enhanced security
 */
export const saveAccessToken = async (accessToken: string): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    try {
      await SecureStorage.set("jwt_access_token", accessToken);
    } catch (error) {
      console.error("Failed to save access token:", error);
    }
  }
  // For web platforms, tokens are managed via HTTP-only cookies
};

/**
 * Get stored JWT access token
 * Mobile: Retrieve from SecureStorage
 * Web: Handled by HTTP-only cookies automatically
 */
export const getAccessToken = async (): Promise<string | null> => {
  if (Capacitor.isNativePlatform()) {
    try {
      const result = await SecureStorage.get("jwt_access_token");
      return typeof result === "string" ? result : null;
    } catch (error) {
      // Item not found or other error - return null so user needs to log in
      console.error("Failed to get access token:", error);
      return null;
    }
  }
  return null; // Web platforms use HTTP-only cookies
};

/**
 * Clear all authentication data
 */
export const clearAuthData = async (): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    try {
      await SecureStorage.remove("jwt_access_token");
    } catch (error) {
      // Token doesn't exist or other error - that's fine for clearing
      console.error("Failed to clear auth data:", error);
    }
  }
  // For web platforms, logout endpoint will clear HTTP-only cookies
};
